import { API_ENDPOINTS, HANG_UP_SUBACTIONS, SM_QUEUE_SERVER } from "../constants/constants";
import { MESSAGE_CODE, MESSAGE_FROM, MESSAGE_TYPE } from "../constants/Notifications";
import { messageHangUp, messageStartStopRecording, triggerNotifications } from "../Helpers/helperMessages";
import { generateAudio } from "./audiosSDK";

export const setSvrVolumen = (that, volSpeaker, volMicrophone) => {
    that.sharedData.setVolumeSpeaker(volSpeaker);
    that.sharedData.setVolumeMic(volMicrophone);
    that.sharedData.setPrevVolumenMicro(volMicrophone);
    that.agentController.volumeSpeaker(volSpeaker);
    that.agentController.volumeMicrophone(volMicrophone);
    const valuesVolume = {
        volumeSpeaker: volSpeaker,
        volumeMicrophone: volMicrophone,
    }
    that.svrEvents.onChangeVolume(valuesVolume);
}

export const setSvrMute = (that) => {
    const isMute = !that.sharedData.getIsMute();
    let newVol = 0;
    if (!isMute) {
        newVol = that.sharedData.getPrevVolumenMicro();
    }
    that.sharedData.setVolumeMic(newVol);
    that.agentController.volumeMicrophone(newVol);
    const valueMute = {
        isMute:isMute,
    }
    that.sharedData.setIsMute(isMute);
    that.svrEvents.onMute(valueMute);
}

export const setSvrStopStartRecording = (that) => {
    let agentRecording = that.sharedData.getGeneralPermissions()[142];
    if (agentRecording === '0') {
        console.warn('The Agent does not have permission to stop/start record the call.');
        triggerNotifications(that, MESSAGE_CODE.CALL_CONTROLS[10706], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK);
        that.svrEvents.onStopStartRecording({
            isEnableStopStartCall : false,
            isStop: null,
        });
        return;
    }
    if (!that.sharedData.getStartStopRecording()) {
        console.warn('The campaign or the agent doesnt have permission to stop/start record the call');
        triggerNotifications(that, MESSAGE_CODE.CALL_CONTROLS[10707], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK);
        that.svrEvents.onStopStartRecording({
            isEnableStopStartCall : false,
            isStop: null,
        });
        return;
    }
    const isRecord = !that.sharedData.getIsStopRecording();
    that.sharedData.setIsStopRecording(isRecord);
    const message = messageStartStopRecording(isRecord, that.callOutId);
    that.sendToRabbit(SM_QUEUE_SERVER, message);

    that.svrEvents.onStopStartRecording({
        isEnableStopStartCall : true,
        isStop: isRecord,
    });
}

export const setSvrHoldCall = (that) => {
    if (!that.sharedData.getPermissionHoldCamp()) {
        console.warn('The campaign doesnt have permission to hold the call');
        triggerNotifications(that, MESSAGE_CODE.CALL_CONTROLS[10705], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK);
        that.svrEvents.onHoldCall({
            isEnableHoldCall : false,
            isHold: null,
        });
        return;
    }

    const message = {
        action: "Api",
        username: that.sharedData.getUserData().Login,
        userID: that.sharedData.getUserData().User_id,
        Subaction: API_ENDPOINTS.HOLD,
    };

    that.sendToRabbit(SM_QUEUE_SERVER, message);

    const isHold = !that.sharedData.getIsHold();
    that.sharedData.setIsHold(isHold);

    that.svrEvents.onHoldCall({
        isEnableHoldCall : true,
        isHold: isHold,
    });
}

export const setSvrdigitDTMF = (that, digit) => {
    switch (digit) {
        case '*':
            generateAudio(that, 'dtmfasterisk', 1);
            break;
        case '#':
            generateAudio(that, 'dtmfhash', 1);
            break;
        default:
            generateAudio(that, 'dtmf'+digit, 1);
            break;
    }
    if (digit.length === 1) {
        setTimeout(() => {
            that.agentController.dtmf(digit);
        }, 20);
    } else {
        for (let i in digit) {
            setTimeout(() => {
                that.agentController.dtmf(digit[i]);
            }, 50 * (i + 1));
        }
    }
}

export const svrHangUpAndLeaveMessage =(that) => 
{
    const callIcon = that.sharedData.getCallIcon();
    if (!callIcon) { 
        console.warn("Cannot retrieve call icon."); 
        triggerNotifications(that, MESSAGE_CODE.CALL_CONTROLS[10701], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK); 
        return;
    }
    const { LeaveRecMessage } = callIcon;
    if(!LeaveRecMessage){
        console.warn("Cannot Hang Up and Leave Message in this campaign.");
        triggerNotifications(that, MESSAGE_CODE.CALL_CONTROLS[10708], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK);
        return;
    }
    const structuraMessageHang= messageHangUp(HANG_UP_SUBACTIONS.LEAVE_MESSAGE,0);
    console.log("hangupAndLeaveMessage");
    that.sendToRabbit(SM_QUEUE_SERVER, structuraMessageHang);
    triggerNotifications(that, MESSAGE_CODE.CALL_CONTROLS[10709], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK);
}
